// extracted by mini-css-extract-plugin
module.exports =  {"fs-badge-checkbox-form-checkboxes":"BadgeCheckboxes-module__fs-badge-checkbox-form-checkboxes___CVP45"};